export interface SpaceTimeDBBackendPlan {
  status: 'planned';
  reason: string;
  candidateTables: string[];
  firstUseCases: string[];
}

export const spaceTimeDBBackendPlan: SpaceTimeDBBackendPlan = {
  status: 'planned',
  reason:
    'The current library is a static TypeScript frontend on GitHub Pages. If we need authenticated edits, live contribution queues, sync jobs, or realtime claim/market overlays, SpaceTimeDB is the preferred backend path.',
  candidateTables: ['articles', 'source_snapshots', 'contribution_queue', 'claim_notes', 'market_observations'],
  firstUseCases: ['community edit submissions', 'manual data review workflow', 'live source-sync history'],
};
